const AGREED = true;
const NOTAGREED = false;

export const isInfoShared = {
    [AGREED]: "Agreed", 
    [NOTAGREED]: "Not agreed",
}
